import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import PropTypes from 'prop-types';

import {
  SCTA,
  SContainer,
  SPreText,
  STitleText,
  SButton,
  SImage,
} from './styles.js';
import DotSVG from 'components/DotSVG/index.js';
import Button from 'components/Button/index.js';

const CTAWithImage = props => {
  return (
    <SCTA>
      {!props.hideDotSVG ? (
        <DotSVG bottom $moveY="0" isVisibleMobile={true} />
      ) : null}
      <SImage filename={props.filename || 'house_cta.png'} />
      <SContainer>
        <Row>
          <Col>
            <SPreText>{props.slug || 'GET IN TOUCH WITH US'}</SPreText>
            <STitleText>
              {props.mainText || 'Get the most out of your property'}
            </STitleText>
            <Button
              $backgroundColor="accent"
              variant="full"
              $withArrow={true}
              onClick={props.onClick}
              buttonID={props.buttonID}
            >
              {props.btnText || 'Get In touch'}
            </Button>
            {/* <Button to={``}>
                {props.btnText || 'Get In touch'}{' '}
                <BsArrowRight className="ms-3" />
              </Button> */}
          </Col>
        </Row>
      </SContainer>
    </SCTA>
  );
};

CTAWithImage.propTypes = {
  filename: PropTypes.string,
  buttonID: PropTypes.string,
  slug: PropTypes.string,
  mainText: PropTypes.any,
  btnText: PropTypes.string,
  onClick: PropTypes.any,
  hideDotSVG: PropTypes.bool,
};

export default CTAWithImage;
